import fetch from "auth/FetchInterceptor"

const CategoriesService = {}

const categoriesEndpointPrefix = "/category"

CategoriesService.getCategories = async () =>
  await fetch(`${categoriesEndpointPrefix}/getAllCategoriesForAdminSchool`, {
    method: "GET",
  })

CategoriesService.getCategoryById = async (id) =>
  await fetch(
    `${categoriesEndpointPrefix}/getOneCategoryForAdminSchool/${id}`,
    {
      method: "GET",
    }
  )

CategoriesService.createCategory = async (data) =>
  await fetch(`${categoriesEndpointPrefix}/create`, {
    data,
    method: "POST",
  })

CategoriesService.updateCategory = async (id, data) => {
  return fetch(`${categoriesEndpointPrefix}/update/${id}`, {
    data,
    method: "PUT",
  })
}

CategoriesService.deleteCategoryById = async (id) =>
  await fetch(`${categoriesEndpointPrefix}/deleteById/${id}`, {
    method: "DELETE",
  })

export default CategoriesService
